
import {zip as observableZip,  Observable } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { CategoryAndLocationHelpers } from '../../helpers';
import { AddExtraAlertDto } from '../../models/account/account.models';
import { SelectableCategory } from '../../models/categories/category.models';
import { LocationsByRegionDto, SelectableLocation, SelectableRegion } from '../../models/locations/location.models';
import { AccountService } from '../../services/account.service';
import { CategoryService } from '../../services/category.service';
import { LocationService } from '../../services/location.service';

@Component({
    selector: 'add-extra-alert',
    template: require('./add.extra.alert.component.html'),
    styles: [require('./personal.account.shared.css'), require('./tender.alert.profile.component.css'), require('./add.extra.alert.component.css')]
})
export class AddExtraAlertComponent implements OnInit, OnDestroy {
    categories: Array<SelectableCategory>;
    locationsByRegion: LocationsByRegionDto;

    showCatLocError = false;
    tooManyCategoriesSelected = false;

    @BlockUI('categories-and-locations-block') private catAndLocBlock : NgBlockUI;

    categoryFilter: string;

    subscribed: boolean;
    userId: number;
    description: string;
    includeAwards: boolean;

    constructor(private readonly categoryService: CategoryService,
        private readonly locationService: LocationService,
        private readonly accountService: AccountService,
        private readonly helpers: CategoryAndLocationHelpers,
        loggedInUserService: LoggedInUserService,
        private readonly router: Router
    ) {

        localStorage.setItem('categoriesSelected', '0');
        localStorage.setItem('tooManyCategoriesSelected', 'false');

        var user = loggedInUserService.getCurrentUser();
        this.userId = user.userId;
        this.subscribed = !user.canAdHoc('notSubscribed');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        var categoryObservable = this.categoryService.getActiveCategories();
        var locationObservable = this.locationService.getActiveLocations();

        observableZip(categoryObservable,
            locationObservable,
            (categories: Array<SelectableCategory>,
                locations: LocationsByRegionDto) => ({ categories, locations }))
            .subscribe(results => {
                this.categories = results.categories;
                this.locationsByRegion = results.locations;
            });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    async filterCategories() {
        if (this.categoryFilter && this.categoryFilter.length >= 3) {
            var filter = this.categoryFilter.toLowerCase();
            this.categories.forEach(async (category: SelectableCategory) => {
                await this.checkIfCategoryOrChildrenMatch(category, filter);
            });
        } else {
            this.categories.forEach((category: SelectableCategory) => { this.showCategoryAndChildren(category) });
        }
    }

    async checkIfCategoryOrChildrenMatch(category: SelectableCategory, filter: string, parent?: SelectableCategory) {
        category.show = category.name.toLowerCase().indexOf(filter) > -1 ||
            (category.keywords && category.keywords.indexOf(filter) > -1);

        if (parent && category.show) {
            parent.show = true;
            parent.isExpanded = true;
        }

        category.children.forEach(async (child: SelectableCategory) => {
            await this.checkIfCategoryOrChildrenMatch(child, filter, category);
        });
    }

    async showCategoryAndChildren(category: SelectableCategory) {
        category.show = true;

        category.children.forEach((child: SelectableCategory) => { this.showCategoryAndChildren(child) });
    }

    changeRegionSelected(region: SelectableRegion) {
        region.locations.forEach((location: SelectableLocation) => {
            location.isSelected = region.isSelected;
        });
    }

    changeLocationSelected(location: SelectableLocation, region?: SelectableRegion) {
        if (!region) {
            return;
        }

        if (region.locations.every((l: SelectableLocation) => { return l.isSelected })) {
            region.isSelected = true;
        } else if (region.locations.every((l: SelectableLocation) => { return !l.isSelected })) {
            region.isSelected = false;
        }
    }

    categoriesChanged() {
        if (!this.categories) {
            return;
        }
        let categoriesSelectedCount = 0;
        this.categories.forEach((category: SelectableCategory) => {
            if (category.children.length == 0) {
                if (category.isSelected) {
                    categoriesSelectedCount++;
                }
            }
            else {
                category.children.forEach((child: SelectableCategory) => {
                    if (child.isSelected) {
                        categoriesSelectedCount++;
                    }
                });
            }
        });

        localStorage.setItem('categoriesSelected', categoriesSelectedCount.toString());

        if (categoriesSelectedCount == 29 && !this.subscribed) {
            this.tooManyCategoriesSelected = false;
            localStorage.setItem('tooManyCategoriesSelected', 'true');
        }
        else if (categoriesSelectedCount > 29 && !this.subscribed) {
            this.tooManyCategoriesSelected = true;
            localStorage.setItem('tooManyCategoriesSelected', 'true');
        }
        else {
            this.tooManyCategoriesSelected = false;
            localStorage.setItem('tooManyCategoriesSelected', 'false');
        }
    }

    save() {
        this.catAndLocBlock.start();
        this.tooManyCategoriesSelected = false;

        var dto: AddExtraAlertDto = {
            categoryIds: [],
            locationIds: [],
            supplierId: this.userId,
            description: this.description,
            includeAwards: this.includeAwards
        };

        var checkCategorySelection = (category: SelectableCategory) => {
            if (category.isSelected) {
                dto.categoryIds.push(category.id);
            }

            category.children.forEach((child: SelectableCategory) => {
                checkCategorySelection(child);
            });
        }

        this.categories.forEach((category: SelectableCategory) => { checkCategorySelection(category); });

        var checkLocationSelection = (location: SelectableLocation) => {
            if (location.isSelected) {
                dto.locationIds.push(location.id);
            }
        }

        this.locationsByRegion.regions.forEach((r: SelectableRegion) => {
            r.locations.forEach((l: SelectableLocation) => { checkLocationSelection(l); });
        });

        this.locationsByRegion.locationsWithoutRegion.forEach((l: SelectableLocation) => {
            checkLocationSelection(l);
        });

        if (dto.categoryIds.length === 0 || dto.locationIds.length === 0) {
            this.showCatLocError = true;
            this.catAndLocBlock.stop();
            return;
        }

        this.accountService.addExtraAlert(dto).subscribe(() => {
            this.catAndLocBlock.stop();
            this.router.navigateByUrl('/account/extraAlerts');
        }, () => {
            this.catAndLocBlock.stop();
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/add.extra.alert.component.ts